/**
 * @description: 根据el和父节点class获取父节点
 * @param   el 节点
 * @param   className 父节点class
 */
export function getParentEl(el: HTMLElement, className: string) {
  let parent = el.parentNode as HTMLElement
  while (parent && !parent.classList.contains(className)) {
    parent = parent.parentNode as HTMLElement
  }
  return parent as HTMLElement
}

/**
 * @description: 根据class,获取el的子节点
 * @param   el 节点
 * @param   className 子节点class
 */
export function getChildEl(el: HTMLElement, className: string) {
  return el.querySelector(`.${className}`) as HTMLElement
}
